
import { MediaContextProvider, Media } from '../../../mobile'

import { useIsTeacher } from '../../../hooks/isTeacher';

import { TeacherClassesView  } from './teacher/TeacherClassesView';
import { AdminClassesView } from './admin/AdminClassesView';

const Classes = () => {
  const isTeacher = useIsTeacher();

  return (
    <MediaContextProvider>
      <Media at='mobile'>
          {isTeacher ? (
            <TeacherClassesView />
          ): (
            <AdminClassesView />
          )}
      </Media>
      <Media greaterThan='mobile'>
        {/* NOTE: this is shown for more than just admins at this time */}
        <AdminClassesView />
      </Media>
    </MediaContextProvider>
  );
}

export { Classes }
